export const AreaData = {
    data() {
        return {
            regionData: {
                list: []
            }
        }
    },
    created() {
        this.$nextTick(() => {
            let region = require('./region.json')
            this.regionData.list = Object.keys(region).map(province => {
                return {
                    key: region[province].code,
                    value: region[province].name,
                    label: region[province].name,
                    children:
                        region[province].children &&
                        Object.keys(region[province].children).map(city => {
                            return {
                                key: region[province].children[city].code,
                                value: region[province].children[city].name,
                                label: region[province].children[city].name,
                                children:
                                    region[province].children[city].children &&
                                    Object.keys(region[province].children[city].children).map(
                                        county => {
                                            return {
                                                key: region[province].children[city].children[
                                                    county
                                                ].code,
                                                value: region[province].children[city].children[
                                                    county
                                                ].name,
                                                label: region[province].children[city].children[
                                                    county
                                                ].name
                                            }
                                        }
                                    )
                            }
                        })
                }
            })
        })
    }
}
